import React from 'react';
import { StyledSideBarCard } from './SideBarCard.style';

const SideBarCard = (props) => {
  return <StyledSideBarCard>{props.children}</StyledSideBarCard>;
};

export default SideBarCard;
